import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["size", "thickness", "color", "className", "dataQaData", "dataQaType", "style"];
import React from 'react';
import cn from 'classnames';
import { dataQa, toPx } from '@tui-react/core';
import styles from './spinner.module.css';
const SIZE_MAP = {
  xxs: 12,
  xs: 16,
  s: 24,
  m: 32,
  l: 40,
  xl: 56,
  xxl: 80
};
const VIEWBOX = 100;
export const Spinner = _ref => {
  let {
      size: propsSize = 'xl',
      thickness: propsThickness,
      color = 'var(--tui-background-accent-1, #FFDD2D)',
      className,
      dataQaData,
      dataQaType = 'tui/spinner',
      style = {}
    } = _ref,
    otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const size = typeof propsSize === 'string' ? SIZE_MAP[propsSize] : propsSize;
  // thickness by default is 1/12 of size
  let thickness = propsThickness != null ? propsThickness : size / 12;
  // adjust thickness to min of 1.5dp
  thickness = thickness > 1.5 ? thickness : 1.5;
  // calculate thickness in viewbox dimensions
  const relativeThickness = VIEWBOX * thickness / size;
  // compensate stroke thickness to calculate radius
  const radius = (VIEWBOX - relativeThickness) / 2;
  const diameter = 2 * Math.PI * radius;
  return /*#__PURE__*/React.createElement("svg", Object.assign({}, dataQa({
    dataQaData,
    dataQaType
  }), {
    focusable: "false"
  }, otherProps, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    className: cn(styles.svg, styles.rotate, className),
    "data-size": size,
    style: _extends({
      '--t-color': color,
      '--t-size': toPx(size),
      '--t-radius': toPx(radius),
      '--t-thickness': toPx(relativeThickness),
      '--t-diameter': toPx(diameter)
    }, style)
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "50",
    cy: "50",
    r: radius,
    strokeDasharray: diameter,
    className: styles.circle
  }));
};